import { createAction, createAsyncAction } from "typesafe-actions";
import type { FetchError } from "app/pages/sales-intelligence/types";
import type { ExportSettingWithType, ExportNotification, ExportSetting, DynamicsExportSettings } from "../../type";
import type { IntegrationStatusResponse } from "../../../components/types";

export const fetchExportSettingsTableAsync = createAsyncAction(
    "@@si/management/dynamics/manage-export/FETCH_EXPORT_SETTINGS_START",
    "@@si/management/dynamics/manage-export/FETCH_EXPORT_SETTINGS_SUCCESS",
    "@@si/management/dynamics/manage-export/FETCH_EXPORT_SETTINGS_FAILURE",
)<void, ExportSettingWithType, FetchError>();

export const fetchDynamicsExportSettingsAsync = createAsyncAction(
    "@@si/dynamics-export/FETCH_DYNAMICS_EXPORT_SETTINGS_START",
    "@@si/dynamics-export/FETCH_DYNAMICS_EXPORT_SETTINGS_SUCCESS",
    "@@si/dynamics-export/FETCH_DYNAMICS_EXPORT_SETTINGS_FAILURE",
)<void, DynamicsExportSettings, FetchError>();

export const saveExportSettingsAsync = createAsyncAction(
    "@@si/management/dynamics/manage-export/SAVE_EXPORT_SETTINGS_START",
    "@@si/management/dynamics/manage-export/SAVE_EXPORT_SETTINGS_SUCCESS",
    "@@si/management/dynamics/manage-export/SAVE_EXPORT_SETTINGS_FAILURE",
)<void, ExportSettingWithType, FetchError>();

export const addNewSettingsExport = createAction(
    "@@si/management/dynamics/manage-export/ADD_NEW_EXPORT_SETTINGS",
)<ExportSettingWithType>();

export const updateDynamicsSettingsExport = createAction(
    "@@si/management/dynamics/manage-export/UPDATE_EXPORT_SETTINGS",
)<ExportSettingWithType>();

export const deleteSettingExport = createAction(
    "@@si/management/dynamics/manage-export/DELETE_EXPORT_SETTING",
)<ExportSettingWithType>();

export const revertSettingsExport = createAction(
    "@@si/management/dynamics/manage-export/REVERT_EXPORT_SETTING",
)<ExportSettingWithType>();

export const setDynamicsEditableField = createAction("@@si/management/dynamics/manage-export/SET_EDITABLE_FIELD")<
    ExportSetting | undefined
>();

export const setDynamicsDeletableField = createAction("@@si/management/dynamics/manage-export/SET_DELETABLE_FIELD")<
    ExportSetting | undefined
>();

export const exportDomainsToAsync = createAsyncAction(
    "@@si/management/dynamics/manage-export/EXPORT_DOMAINS_START",
    "@@si/management/dynamics/manage-export/EXPORT_DOMAINS_SUCCESS",
    "@@si/management/dynamics/manage-export/EXPORT_DOMAINS_FAILURE",
)<void, void, FetchError>();

export const showModalDisabledExport = createAction(
    "@@si/management/dynamics/manage-export/SHOW_MODAL_DISABLED_EXPORT",
)<boolean>();

export const setDynamicsNotification = createAction(
    "@@si/management/dynamics/manage-export/SET_NOTIFICATION",
)<null | ExportNotification>();

export const getAccountsStatusAsync = createAsyncAction(
    "@@si/management/dynamics/manage-integration/GET_ACCOUNTS_STATUS_START",
    "@@si/management/dynamics/manage-integration/GET_ACCOUNTS_STATUS_SUCCESS",
    "@@si/management/dynamics/manage-integration/GET_ACCOUNTS_STATUS_FAILURE",
)<void, boolean, FetchError>();

export const putAccountsStatusAsync = createAsyncAction(
    "@@si/management/dynamics/manage-integration/PUT_ACCOUNTS_STATUS_START",
    "@@si/management/dynamics/manage-integration/PUT_ACCOUNTS_STATUS_SUCCESS",
    "@@si/management/dynamics/manage-integration/PUT_ACCOUNTS_STATUS_FAILURE",
)<void, IntegrationStatusResponse, FetchError>();

export const putContactsToggleAsync = createAsyncAction(
    "@@si/management/dynamics/manage-integration/PUT_CONTACTS_STATUS_START",
    "@@si/management/dynamics/manage-integration/PUT_CONTACTS_STATUS_SUCCESS",
    "@@si/management/dynamics/manage-integration/PUT_CONTACTS_STATUS_FAILURE",
)<void, IntegrationStatusResponse, FetchError>();

export const putLeadsToggleAsync = createAsyncAction(
    "@@si/management/dynamics/manage-integration/PUT_LEADS_STATUS_START",
    "@@si/management/dynamics/manage-integration/PUT_LEADS_STATUS_SUCCESS",
    "@@si/management/dynamics/manage-integration/PUT_LEADS_STATUS_FAILURE",
)<void, IntegrationStatusResponse, FetchError>();

export const saveDynamicsAllSettingsError = createAction(
    "@@si/management/dynamics/manage-export/SAVE_ALL_SETTINGS_ERROR",
)<string>();
